export default "/_next/static/images/4-3562b3ba6077cfc538cb9fbefcda75b6.png";